export const useHomeListAction = () => {
  const getAboutPath = () => `/`;

  const getExtensionPath = () =>
    `https://chromewebstore.google.com/detail/edgen-ai-spot-market-move/gjfilfmjjgkpjbdjohdndhinaonepgei`;

  return {
    getAboutPath,
    getExtensionPath,
  };
};
